import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/homeData';
import { useInView } from '@/hooks/useInView';

export default function LatestSection() {
  const { ref, isInView } = useInView();

  return (
    <section id="latest" className="py-16 md:py-20 bg-background-100">
      <div
        ref={ref}
        className={`px-4 md:px-6 transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="max-w-[1200px] mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 gap-4">
            <div>
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                <i className="ri-time-line mr-1"></i>实时更新
              </span>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading">
                最新更新
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                追踪你喜爱的<strong>免费韩漫</strong>最新章节
              </p>
            </div>
            <Link
              to="/category/rexue"
              className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
            {latestUpdates.map((comic) => (
              <Link
                key={comic.id}
                to="/category/all"
                className="group block cursor-pointer"
              >
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`${comic.title} - 韩漫在线最新章节`}
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-3">
                    <span className="text-xs text-background-50/90 font-medium">
                      {comic.latestChapter}
                    </span>
                  </div>
                </div>
                <div className="mt-2.5">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate font-heading">
                    {comic.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">{comic.category}</span>
                    <span className="text-xs text-accent-500 flex items-center gap-0.5">
                      <i className="ri-star-fill text-[10px]"></i>
                      {comic.rating}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-1">{comic.updateTime}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}